export default __webpack_public_path__ + "static/bg-grain-570c87d1df0dd6433e89cf55bde46a4b.png";